import { http } from '@Techedge/digitalportal-shared'
import {
    GlobalSearchInput,
    GlobalSearchOutput,
    SectionType,
} from '../models/search'

export class GlobalSearchService {
    static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE + `/searchapi`
    static SEARCH_URL: string = GlobalSearchService.BASE_URL + `/search`
    static PREDICTIONS_URL: string =
        GlobalSearchService.BASE_URL + `/search/tips`

    static searchOutputTemplate: GlobalSearchOutput | any = {}

    static mockResult = () => {
        let promise = new Promise(() => {})
        return promise
    }

    static getGlobalSearch = (param: GlobalSearchInput) => {
        return http.post<any>(
            GlobalSearchService.SEARCH_URL,
            {
                ...param,
                search: encodeURIComponent(param.search),
                forceOpt: true,
            },
            {}
        )
    }
    static onSearchPredictions = (param: GlobalSearchInput) => {
        return http.post<any>(
            GlobalSearchService.PREDICTIONS_URL,
            {
                ...param,
                search: encodeURIComponent(param.search),
                forceOpt: true,
            },
            {}
        )
    }
}
